
  import c0 from "@/app/i18n/common/GenericObject.en.yaml"
import c1 from "../BookEntry.en.yaml"
import c2 from "@/app/i18n/common/GenericObject.de.yaml"
import c3 from "../BookEntry.de.yaml"
  export default function (Component) {
    // Component.options.name (if defined) can be used to load component
    // translations by default
    Component.options.__i18n = Component.options.__i18n || []
    Component.options.__i18n.push ('{"en":' + JSON.stringify(c0) + '}')
Component.options.__i18n.push ('{"en":' + JSON.stringify(c1) + '}')
Component.options.__i18n.push ('{"de":' + JSON.stringify(c2) + '}')
Component.options.__i18n.push ('{"de":' + JSON.stringify(c3) + '}')
  }
  